import { AssignStatusFilter } from "@/enum/list.enum";

/**
 * Resolves the initial assign-status filter for the Ready-to-Send (Review) screen from the URL.
 *
 * A review session (`reviewSessionId`) pins the visible leads to an explicit, hand-picked set of
 * listPersonIds, so the status filter must NOT constrain them — otherwise selected non-draft leads
 * (and their connection labels) silently drop out. In that mode we start with no status filter.
 * Otherwise we honour an explicit `assignStatus` param and fall back to DRAFT ("New"). See PREC-3502.
 */
export const getInitialAssignStatusFilter = (search: string): AssignStatusFilter[] => {
	const params = new URLSearchParams(search);

	if (params.get("reviewSessionId")) {
		return [];
	}

	const assignStatusParam = params.get("assignStatus");

	if (!assignStatusParam) {
		return [AssignStatusFilter.DRAFT];
	}

	try {
		return JSON.parse(assignStatusParam) as AssignStatusFilter[];
	} catch {
		return [AssignStatusFilter.DRAFT];
	}
};
